import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "What exactly is the Phase Forward Method?",
    a: "It's my three-phase coaching system — Audit & Assess, Progressive Overload, and Peak Transformation — designed specifically to get men past muscle-building plateaus through structured, periodised progression.",
  },
  {
    q: "Who is this coaching for?",
    a: "Men who train consistently but have stalled — your lifts and your physique aren't moving anymore. If you're committed and ready to follow a plan, this is for you.",
  },
  {
    q: "How long is the program?",
    a: "Most clients run a 12-week transformation block, with the option to continue. Real, lasting change takes structured time — not a quick fix.",
  },
  {
    q: "Do I need a gym membership?",
    a: "A gym makes progress faster, but plans can be adapted to well-equipped home setups. We'll cover your equipment access during onboarding.",
  },
  {
    q: "What happens after I apply?",
    a: "I personally review every application. If we're a good fit, I'll reach out to discuss your goals and get you started with your custom plan.",
  },
];

export const FAQ = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-24 md:py-32 bg-[#0F0F0F] border-t border-white/10"
    >
      <div className="max-w-3xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-3 mb-5">
            <span className="h-px w-10 bg-[#E63946]" />
            <span className="text-xs uppercase tracking-[0.3em] text-neutral-400">
              Questions
            </span>
            <span className="h-px w-10 bg-[#E63946]" />
          </div>
          <h2 className="font-heading font-black uppercase tracking-tight text-3xl sm:text-4xl lg:text-5xl">
            Frequently Asked
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i + 1}`}
              className="border-b border-white/10"
            >
              <AccordionTrigger className="font-heading text-lg sm:text-xl font-bold uppercase tracking-tight text-left hover:no-underline hover:text-[#E63946] py-6">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-neutral-300 leading-relaxed text-base pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
